module.exports = __webpack_public_path__ + "media/assets/images/blog/kanbanboard-drag-ticket-small-8d4f7398f00b6eee22e32e9198387edc.jpeg";